/* Este archivo es autogenerado por scripts/setenv.ts. NO EDITAR MANUALMENTE. */
export const environment = {
  production: false,
  COGNITO_USERPOOL_ID: 'us-east-2_bzZYGhmRB',
  COGNITO_APPCLIENT_ID: '5dbl4jdl1f75tjehdonongdbj6',
  API_URL: 'https://dev-api.dohealth-epione.com/hitec-cobranza',
};
